export const DISPLAY_MAINTENANCE_MODE = 'displayMaintenanceModal';
export const SET_CURRENT_USER = 'setCurrentUser';
export const SET_TOAST = 'setToast';
